import React from "react";

import NotificationSettingsForm from "../forms/Notification";
import "./SettingsPage.scss";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  doCreateNotificationSetting,
  doGetNotificationSettingList,
  doUpdateNotificationSetting
} from "../store/notification-settings/thunks";
import { selectAllNotificationSettings } from "../store/notification-settings/slice";
import { setSuccessMessage } from "app/global/slice";
import profileApi from "modules/client/profile/store/api";

const settingInitial = {
  enableSendSMS: true,
  enableSendEmail: true,
  enableNotifyStartJob: true,
  enableNotifyArrival: true,
  enableNotifyStopCompletion: true,
  enableNotifyGoingNext: true,
  sendScannedDocumentsOnDropoff: false,
  sendPodOnDropoffComplete: false,
  startJobNotificationContent:
    "Your order from {company} is en route! Track status here: {tracking_link}",
  arrivalNotificationContent: "Your order from {company} has arrived.",
  stopCompletionNotificationContent: "Your order from {company} has been completed!",
  goingNextNotificationContent:
    "Your order from {company} is te next stop! Track status here: {tracking_link}",
  notificationFields: {
    stop_id: "FX38274845",
    stop_name: "Central Drug",
    user_name: "Don Fulanito",
    contact_name: "James Nguyen",
    company: "Flexio",
    eta: "09:10 - 11:10",
    cod: "500",
    driver_name: "Driver La",
    driver_phone: "+15417543010",
    tracking_link: "https://app.goflexio.com/s/3e8ee5a0",
    driver_feedback_link: "https://app.goflexio.com/s/dfb/3e8ee5a0"
  }
};

const NotificationSetting = () => {
  const [setting, setSetting] = useState(settingInitial);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.global.isLoading);
  const notiSettings = useSelector(selectAllNotificationSettings);
  const [profile, setProfile] = useState({});

  useEffect(() => {
    dispatch(doGetNotificationSettingList());
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      const profileRes = await profileApi.getProfile();
      if (!profileRes) return;
      const { client, phone } = profileRes;
      setProfile({
        ...profileRes,
        ...(profileRes.client || {}),
        phone: phone || "",
        supportPhone: client.supportPhone || "",
        sendScannedDocumentsOnDropoff:
          profileRes.client?.sendScannedDocumentsOnDropoff || false,
        sendPodOnDropoffComplete: profileRes.client?.sendPodOnDropoffComplete || false
      });
    } catch (err) {
      console.log(err);
    }
  };
  settingInitial.notificationFields.customer_name = profile?.fullName || "";
  settingInitial.notificationFields.company = profile?.clientName || "";
  useEffect(() => {
    if (notiSettings?.length) {
      setSetting({
        ...notiSettings[0],
        sendScannedDocumentsOnDropoff: profile?.sendScannedDocumentsOnDropoff || false,
        sendPodOnDropoffComplete: profile?.sendPodOnDropoffComplete || false,
        notificationFields: settingInitial.notificationFields
      });
    }
  }, [notiSettings, profile]);

  const handleOnFinish = async (data) => {
    const { sendScannedDocumentsOnDropoff, sendPodOnDropoffComplete, ...notiData } = data;

    console.log("Notification settings data:", {
      sendScannedDocumentsOnDropoff,
      sendPodOnDropoffComplete,
      notiData
    });
    console.log("Profile data:", profile);

    try {
      // Validate we have all required profile data
      if (
        !profile.firstName ||
        !profile.lastName ||
        !profile.email ||
        !profile.phone ||
        !profile.country ||
        !profile.address ||
        profile.lat === undefined ||
        profile.lat === null ||
        profile.lng === undefined ||
        profile.lng === null
      ) {
        console.error("Missing required profile data:", profile);
        dispatch(
          setSuccessMessage(
            "Error: Missing required profile information. Please complete your profile first."
          )
        );
        return;
      }

      if (notiData?.id) {
        const { error } = await dispatch(doUpdateNotificationSetting(notiData));
        if (!error) {
          await profileApi.updateProfile({
            firstName: profile.firstName,
            lastName: profile.lastName,
            phone: profile.phone,
            email: profile.email,
            country: profile.country,
            address: profile.address,
            lat: profile.lat,
            lng: profile.lng,
            isSummaryEmail: profile.isSummaryEmail || false,
            summaryEmail: profile.summaryEmail || null,
            sendScannedDocumentsOnDropoff: sendScannedDocumentsOnDropoff || false,
            sendPodOnDropoffComplete: sendPodOnDropoffComplete || false
          });

          // Update local profile state to reflect the changes
          setProfile((prevProfile) => ({
            ...prevProfile,
            sendScannedDocumentsOnDropoff: sendScannedDocumentsOnDropoff || false,
            sendPodOnDropoffComplete: sendPodOnDropoffComplete || false
          }));

          dispatch(setSuccessMessage("Updated successfully!"));
        }
      } else {
        const { error } = await dispatch(doCreateNotificationSetting(notiData));
        if (!error) {
          await profileApi.updateProfile({
            firstName: profile.firstName,
            lastName: profile.lastName,
            phone: profile.phone,
            email: profile.email,
            country: profile.country,
            address: profile.address,
            lat: profile.lat,
            lng: profile.lng,
            isSummaryEmail: profile.isSummaryEmail || false,
            summaryEmail: profile.summaryEmail || null,
            sendScannedDocumentsOnDropoff: sendScannedDocumentsOnDropoff || false,
            sendPodOnDropoffComplete: sendPodOnDropoffComplete || false
          });

          // Update local profile state to reflect the changes
          setProfile((prevProfile) => ({
            ...prevProfile,
            sendScannedDocumentsOnDropoff: sendScannedDocumentsOnDropoff || false,
            sendPodOnDropoffComplete: sendPodOnDropoffComplete || false
          }));

          dispatch(setSuccessMessage("Created successfully!"));
        }
      }
    } catch (error) {
      console.error("Error updating notification settings:", error);
      dispatch(setSuccessMessage("Error updating settings. Please try again."));
    }
  };

  return (
    <div className="settings-page">
      <div className="setting-content">
        <NotificationSettingsForm
          isFetching={isLoading}
          setting={setting}
          handleSubmit={handleOnFinish}
        />
      </div>
    </div>
  );
};

export default NotificationSetting;
